// import { create } from "zustand";
// import { persist } from "zustand/middleware";

// export const useAuthStore = create(persist((set) => ({
//   accessToken: localStorage.getItem("accessToken"),
//   refreshToken: localStorage.getItem("refreshToken"),
//   user: JSON.parse(localStorage.getItem("user")),
//   isAuthenticated: !!localStorage.getItem("accessToken"),

//   login: ({ access, refresh, user }) => {
//     localStorage.setItem("accessToken", access);
//     localStorage.setItem("refreshToken", refresh);
//     localStorage.setItem("user", JSON.stringify(user));

//     set({
//       accessToken: access,
//       refreshToken: refresh,
//       user,
//       isAuthenticated: true,
//     });
//   },

//   logout: () => {
//     localStorage.removeItem("accessToken");
//     localStorage.removeItem("refreshToken");
//     localStorage.removeItem("user");

//     set({
//       accessToken: null,
//       refreshToken: null,
//       user: null,
//       isAuthenticated: false,
//     });
//   },
// })));

import { create } from "zustand";
import { persist } from "zustand/middleware";

export const useAuthStore = create(
  persist(
    (set, get) => ({
      accessToken: null,
      refreshToken: null,
      user: null,
      permissions: {},
      isAuthenticated: false,

      login: ({ access, refresh, user }) => {
        set({
          accessToken: access,
          refreshToken: refresh,
          user,
          isAuthenticated: true,
        });
      },

      setPermissions: (permissions) => {
        set({ permissions });
      },

      logout: () => {
        set({
          accessToken: null,
          refreshToken: null,
          user: null,
          permissions: {},
          isAuthenticated: false,
        });
      },

      hasPermission: (key) => {
        // return true
        return !!get().permissions[key];
      },
    }),
    {
      name: "auth-storage",
    }
  )
);
